interface state extends types.redux.rootReducer {}

export const emailSelector = ({ session }: state) => session.user.email;

export const contactNumberSelector = ({ session }: state) => session.user.contactNumber1;

export const accountNameSelector = ({ session }: state) => session.user.accountName;

export const upIdSelector = ({ session }: state) => session.user.upId;

export const userIdSelector = ({ session }: state) => session.user.userId;

export const userNameSelector = ({ session }: state) => session.user.userName;

export const userTypeSelector = ({ session }: state) => session.user.userType;

export const loginSelector = ({ session }: state) => session.login;

export const sessionSelector = ({ session }: state) => session;

export const isLoggedInSelector = ({ session }: state) => session.authenticated && session.authorized;

export const showWelcomeModalSelector = ({ session }: state) => session.showWelcomeModal;

export const departmentPermissionsSelector = ({ session }: state) => session.user.departmentPermissions;

export const accountPermissionsSelector = ({ session }: state) => session.user.accountPermissions;

export const userContactNumberSelector = ({ session }: state) => session.user.contactNumber1;

export const nmfloIdSelector = ({ session }: state) => session.user.nmfloId;
export const isWeakPassword = ({ session }: state) => session.isWeakPassword;
export const OTPModalOpen = ({ session }: state) => session?.isOTPModalOpen;
export const isAuthenticating = ({ session }: state) => session?.isAuthenticating;

export const userData = ({ session }: state) => {
	return {
		userName: session.user.userName,
		email: session.user.email,
		contactNumber: session.user.contactNumber1,
		organizationName: session.user.accountName,
		useType: session.user.userType,
	};
};
